import { FC } from 'react';
import { DAFConfirmation } from './DAF';
import { StripeConfirmation } from './Stripe';
import { PledgeConfirmation } from './Pledge';
import { Routes, Route } from 'react-router-dom';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { IPage } from 'store/donatePage/types';
import { IEvent } from 'store/eventPage/types';
import { StripeElementsProvider } from './Stripe/Provider';
import { OathRecurringInterval } from 'store/pay/types';

interface Props {
  candidates: CandidateType[];
  donationAmount: number;
  page?: IPage | IEvent;
  isEvent: boolean;
  isRecurring: boolean;
  pageImage: string;
  recurringInterval?: OathRecurringInterval;
}

export const Confirmation: FC<Props> = ({
  candidates,
  donationAmount,
  isEvent,
  isRecurring,
  pageImage,
  page,
  recurringInterval = 'month',
}) => {
  const numRecipients = candidates.filter(candidate => (candidate?.donationAmount ?? 0) > 0).length;
  return (
    <Routes>
      <Route
        path="daf"
        element={
          <DAFConfirmation
            candidates={candidates}
            donationAmount={donationAmount}
            isEvent={isEvent}
            pageImage={pageImage}
          />
        }
      />
      <Route
        path="standard"
        element={
          <StripeElementsProvider>
            <StripeConfirmation
              donationAmount={donationAmount}
              isRecurring={isRecurring}
              numRecipients={numRecipients}
              page={page}
              recurringInterval={recurringInterval}
            />
          </StripeElementsProvider>
        }
      />
      <Route path="pledge/:pledgeMethod" element={<PledgeConfirmation page={page} />} />
    </Routes>
  );
};
